import { Formik } from "formik";
import { useNavigate } from "react-router";
import Header from "../components/Header";
import Loader from "../components/Loader";
import Sidebar from "../components/Sidebar";
import SubHeader from "../components/SubHeader";
import { pageRoutes } from "../routes/PageRoutes";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { changePassword } from "../redux/actions/authActions";
import { ChangePasswordSchema } from "../auth/Schema";

const ChangePassword = () => {
  const { isLoading } = useSelector((state) => state?.authReducer);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isToggle, setIsToggle] = useState(false);
  const [showCurrent, setShowCurrent] = useState(false);
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const onHandleClick = () => {
    setIsToggle(!isToggle);
  };
  const handleChangePassword = (values, { setSubmitting, resetForm }) => {
    setSubmitting(true);

    const payload = {
      current_password: values.password,
      password: values.new_password,
      confirm_password: values.confirm_password,
    };

    const callback = (response, error) => {
      setSubmitting(false);
      if (response?.success) {
        resetForm();
        navigate(pageRoutes?.dashboard);
      }
    };

    dispatch(changePassword({ payload, callback }));
  };

  return (
    <div className="ct_dashbaord_bg">
      <div
        className={`ct_dashbaord_main ${isToggle === false ? "ct_active" : ""}`}
      >
        <Sidebar path="business_profile" />

        <div className="ct_content_right">
          <Header onClick={onHandleClick} />

          <div className="ct_px_23 ct_mt_30 pb-5">
            <div className="ct_mb_30">
              <SubHeader />
            </div>
            <Formik
              initialValues={{
                password: "",
                new_password: "",
                confirm_password: "",
              }}
              validationSchema={ChangePasswordSchema}
              onSubmit={handleChangePassword}
              enableReinitialize
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                resetForm,
                isSubmitting,
              }) => (
                <form onSubmit={handleSubmit} noValidate>
                  <div className="ct_wrapper_white_box">
                    <div className="row">
                      <div className="col-md-12 ct_mb_30">
                        <label className="form-label">
                          Current Password{" "}
                          <span className="ct_required_star">*</span>
                        </label>

                        <div className="position-relative">
                          <input
                            type={showCurrent ? "text" : "password"}
                            id="password"
                            name="password"
                            className="form-control ct_input ct_transparent_input pe-5"
                            placeholder="Enter current password"
                            value={values.password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <div onClick={() => setShowCurrent(!showCurrent)}>
                            <i
                              className={`fa-solid ${
                                showCurrent ? "fa-eye" : "fa-eye-slash"
                              } ct_show_eye ct_pointer`}
                            />
                          </div>
                        </div>

                        {errors.password && touched.password && (
                          <span className="text-danger d-block mt-1">
                            {errors.password}
                          </span>
                        )}
                      </div>
                      <div className="col-md-12 ct_mb_30">
                        <label className="form-label">
                          New Password{" "}
                          <span className="ct_required_star">*</span>
                        </label>

                        <div className="position-relative">
                          <input
                            type={showNew ? "text" : "password"}
                            id="new_password"
                            name="new_password"
                            className="form-control ct_input ct_transparent_input pe-5"
                            placeholder="Enter new password"
                            value={values.new_password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <div onClick={() => setShowNew(!showNew)}>
                            <i
                              className={`fa-solid ${
                                showNew ? "fa-eye" : "fa-eye-slash"
                              } ct_show_eye ct_pointer`}
                            />
                          </div>
                        </div>

                        {errors.new_password && touched.new_password && (
                          <span className="text-danger d-block mt-1">
                            {errors.new_password}
                          </span>
                        )}
                      </div>
                      <div className="col-md-12 ct_mb_30">
                        <label className="form-label">
                          Confirm Password{" "}
                          <span className="ct_required_star">*</span>
                        </label>

                        <div className="position-relative">
                          <input
                            type={showConfirm ? "text" : "password"}
                            id="confirm_password"
                            name="confirm_password"
                            className="form-control ct_input ct_transparent_input pe-5"
                            placeholder="Enter confirm password"
                            value={values.confirm_password}
                            onChange={handleChange}
                            onBlur={handleBlur}
                          />
                          <div onClick={() => setShowConfirm(!showConfirm)}>
                            <i
                              className={`fa-solid ${
                                showConfirm ? "fa-eye" : "fa-eye-slash"
                              } ct_show_eye ct_pointer`}
                            />
                          </div>
                        </div>

                        {errors.confirm_password &&
                          touched.confirm_password && (
                            <span className="text-danger d-block mt-1">
                              {errors.confirm_password}
                            </span>
                          )}
                      </div>

                    </div>
                  </div>
                  <div className="d-flex justify-content-end gap-3 ct_mt_40">
                    <button
                      type="button"
                      onClick={() => resetForm()}
                      className="ct_border_radius_5 ct_h_40 ct_orange_transparent_btn"
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      disabled={isSubmitting || isLoading}
                      className="ct_border_radius_5 ct_h_40 ct_orange_btn"
                    >
                      {isSubmitting || isLoading ? "Saving..." : "Save Changes"}
                    </button>
                  </div>
                </form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
